import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonModel } from '@notino/react-styleguide-v20';
import { trackingEvent } from '@notino/web-tracking';

import { useTrackingContext } from '@context/TrackingContext';
import { dispatchEcommerceMessage } from '@services/messagingService';
import { useRedirect } from '@services/routingService';
import { EPage, ReactFCV } from '@types';

import { IDiscoveryBoxItem } from '../../model';

import { DiscoverySampleProduct } from './components/DiscoverySampleProduct';
import { messages } from './messages';
import {
  DiscoveryBoxModalBodyWrapper,
  StyledDiscoveryBoxModalTitle,
  StyledDiscoveryBoxActionButton,
  StyledDiscoveryBoxFooter,
} from './styled';

export interface IDiscoveryBoxModalBodyProps {
  itemId: number;
  products: IDiscoveryBoxItem[];
}

export const DiscoveryBoxModalBody: ReactFCV<IDiscoveryBoxModalBodyProps> = ({ itemId, products }) => {
  const redirectMethod = useRedirect();
  const { getTimeFromInit } = useTrackingContext();

  const redirectDiscoveryBoxEdit = useCallback(() => {
    dispatchEcommerceMessage(
      trackingEvent({
        event: 'discovery_box_dialog_edit',
        discovery_box: {
          name: 'cart',
          type: 'box',
          timing: getTimeFromInit(),
          action: 'discovery_box_dialog_edit',
          value: products.length,
          interaction: 'button',
        },

        _clear: true,
      }),
    );
    redirectMethod(EPage.DISCOVERY_BOX, `?id=${itemId}`);
  }, [getTimeFromInit, products.length, redirectMethod, itemId]);

  useEffect(() => {
    dispatchEcommerceMessage(
      trackingEvent({
        event: 'discovery_box_dialog_view',
        discovery_box: {
          name: 'cart',
          type: 'box',
          timing: getTimeFromInit(),
          action: 'discovery_box_dialog_view',
          value: products.length,
          interaction: 'click',
        },

        _clear: true,
      }),
    );
  }, [getTimeFromInit, products.length]);

  return (
    <DiscoveryBoxModalBodyWrapper>
      <StyledDiscoveryBoxModalTitle>
        <FormattedMessage {...messages.modalTitle} />
      </StyledDiscoveryBoxModalTitle>
      <div>
        {products.map((product) => (
          <DiscoverySampleProduct key={product.productId} {...product} />
        ))}
      </div>
      <StyledDiscoveryBoxFooter>
        <StyledDiscoveryBoxActionButton
          buttonStyle={ButtonModel.Styles.secondary}
          buttonSize={ButtonModel.Sizes.default}
          onClick={redirectDiscoveryBoxEdit}>
          <FormattedMessage {...messages.buttonText} />
        </StyledDiscoveryBoxActionButton>
      </StyledDiscoveryBoxFooter>
    </DiscoveryBoxModalBodyWrapper>
  );
};
